import { ConstConfig } from '@/constants'

const UrlUtil = {
  /**
   * 获取URL参数，不含hash中query参数
   * e.g http://dommin/?code=123#/path => [{ code: 123 }]
   * e.g http://dommin?code=123 => [{ code: 123 }]
   * e.g http://dommin/?code=123#/path?a=456 => [{ code: 123 }]
   * @param {string} urlString url绝对地址 <Optional>
   * @returns {Array}
   */
  getUrlQueryParams: urlString => {
    const urlObj = new URL(urlString || window.location.href)
    const queryArr = urlObj.search.match(new RegExp(/[?&][^?&]+=[^?&]+/, 'g'))
    if (!queryArr) {
      return null
    }
    const ret = {}
    for (let i = 0; i < queryArr.length; i++) {
      const obj = queryArr[i].substring(1)
      const [key, val] = obj.split('=')
      ret[key] = val
    }
    return ret
  },
  /**
   * 获取URL参数，包含hash中query参数
   * @param {string} url url绝对地址 <Optional>
   * @param {string} name url绝对地址 <Optional>
   * @returns {Array}
   */
  getQueryValByName: (name, url) => {
    url = url == null ? window.location.href : url
    const reg = new RegExp('(^|&|/?)' + name + '=([^&|/?]*)(&|/?|$)', 'i')
    const r = url.substr(1).match(reg)
    if (r != null) {
      let val = r[2]
      // 处理单页面url中#问题
      const idx = val.indexOf('#')
      if (idx > -1) {
        val = val.substring(0, idx)
      }
      return val
    }
    return null
  },
  /**
   * 获取URL参数，包含hash中query参数
   * @param {string} <Optional> url url绝对地址
   * @returns {Array}
   */
  getHashQueryParams: url => {
    url = url == null ? window.location.href : url
    let search = url.substring(url.lastIndexOf('?') + 1)
    // 处理单页面url中#问题
    const idx = search.indexOf('#')
    if (idx > -1) {
      search = search.substring(0, idx)
    }
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
      const name = decodeURIComponent($1)
      let val = decodeURIComponent($2)
      val = String(val)
      obj[name] = val
      return rs
    })
    return obj
  },
  queryObjectToString: params => {
    const ret = []
    params = params || {}
    for (const key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        ret.push(key + '=' + encodeURIComponent(params[key]))
      }
    }
    return ret.join('&')
  },
  // getAppPath: name => {
  //   let path = `${name}-dev`
  //   if (process.env.VUE_APP_ENV === 'prod') {
  //     path = name
  //   } else if (process.env.VUE_APP_ENV === 'dev') {
  //     path = ''
  //   }
  //   return `${ConstConfig.siteUrl}` // /${path}
  // },
  getAppPath: () => {
    return `${ConstConfig.siteUrl}` // /${path}
  }
}

export { UrlUtil }
